module.exports = __webpack_public_path__ + "assets/img/mecha-active-btn-36130d4e.png";